/**
 * TaskAnalyticsPage - Task performance analytics dashboard
 *
 * Surfaces the TaskAnalyticsDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides insights into task completion rates, duration distributions, and bottlenecks.
 *
 * Route: /admin/task-analytics
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconChecklist } from '@tabler/icons-react';

import { TaskAnalyticsDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function TaskAnalyticsPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="teal">
            <IconChecklist size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Task Analytics</Title>
            <Text size="sm" c="dimmed">
              Task completion rates, duration analysis, and workflow bottlenecks
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <TaskAnalyticsDashboard tenantId={tenant?.id ?? ''} />
    </Container>
  );
}

export default TaskAnalyticsPage;
